import * as React from "react"
import { PropsWithChildren } from "react"

import { DecorateContainer, DecoratorLabel, Header, HeaderIconAnimation, HeroImage, HeroImageAnimation } from "./styles"
import { HeaderImage, useHeaderImages } from "../../../hooks/use-header-images"
import BrandComponent, { BrandData } from "../../core/brand"
import { useFooterData } from "../../../hooks/use-footer-data"

export enum HeaderSize {
  Small = 25,
  Medium = 50,
  Large = 75
}

export interface HeaderConfig {
  image: string;
  decorate: string;
  size: HeaderSize
}

function DecoratorComponent(props: PropsWithChildren<{ brand: BrandData, decoratorLabel: string }>) {
  return (
    <DecorateContainer>
      <BrandComponent animate={HeaderIconAnimation} className={"decorate"} brand={props.brand}/>
      <DecoratorLabel {...HeaderIconAnimation}>{props.decoratorLabel}</DecoratorLabel>
    </DecorateContainer>
  )
}

function hasDecoration(decoration: string): boolean {
  return !!decoration && decoration.length > 0;
}

export default function HeaderComponent(props: PropsWithChildren<HeaderConfig>) {
  const { alt, srcSet } = useHeaderImages().find((headerImage: HeaderImage) => headerImage.page === props.image)
  const { brand } = useFooterData()

  return (
    <Header size={props.size || HeaderSize.Medium}>
      {hasDecoration(props.decorate) ? <DecoratorComponent brand={brand} decoratorLabel={props.decorate}/> : null}
      <HeroImage {...HeroImageAnimation} srcSet={srcSet} alt={alt}/>
    </Header>
  )
}
